(() => {
  if (window.__peakProductCardNavigation) return;
  window.__peakProductCardNavigation = true;

  const interactiveSelector =
    'a, button, input, select, textarea, label, summary, details, form, [role="button"], [contenteditable="true"]';

  const getCard = target =>
    target instanceof Element
      ? target.closest('[data-product-card-link][data-product-url]')
      : null;

  document.addEventListener('click', event => {
    const card = getCard(event.target);
    if (!card) return;

    /* Preserve native links and real controls inside a card. */
    if (event.target.closest(interactiveSelector)) return;

    const url = card.dataset.productUrl;
    if (!url) return;

    window.location.assign(url);
  });

  document.addEventListener('auxclick', event => {
    if (event.button !== 1) return;

    const card = getCard(event.target);
    if (!card || event.target.closest(interactiveSelector)) return;

    const url = card.dataset.productUrl;
    if (!url) return;

    window.open(url, '_blank', 'noopener,noreferrer');
  });
})();
